import { mailApiGet, mailApiPost } from "@/lib/api/client";

/** Shape journal (évite import circulaire avec mailMutationProgress). */
export type ActivityJournalJobPayload = {
  id: string;
  label: string;
  phase: string;
  kind?: string;
  error?: string;
  errorAcknowledged?: boolean;
  keepHistory?: boolean;
  createdAt: number;
  updatedAt: number;
  progress?: { done: number; total: number };
  steps?: Array<{
    id: string;
    label: string;
    status: string;
    error?: string;
  }>;
};

type ListResponse = {
  success: boolean;
  weekStart?: number;
  jobs: ActivityJournalJobPayload[];
};

type UpsertResponse = {
  success: boolean;
  saved: number;
};

type ClearResponse = {
  success: boolean;
  cleared: number;
};

export function fetchActivityJournal() {
  return mailApiGet<ListResponse>("journal/list.php");
}

export function upsertActivityJournal(jobs: ActivityJournalJobPayload[]) {
  return mailApiPost<UpsertResponse>("journal/upsert.php", { jobs });
}

export function clearActivityJournal() {
  return mailApiPost<ClearResponse>("journal/clear.php", {});
}
